import { GridConfig } from '@inavista/components/grid';

// RIMS grid look (Martin, 2026-11-04): every status column is centred, its header stays left. A status column is
// one named "status" or ending in "Status" (equipmentStatus, partsOrderStatus, exceptionStatus ...). statusSort and
// other helpers do not match. Wraps a grid config so no grid has to list its status columns by hand.
const STATUS_COLUMN = /^(status|[a-z][A-Za-z]*Status)$/;

export function centreStatusColumns(config: GridConfig): GridConfig {
  const columns = new Set<string>([
    ...(config.defaultColumnOrder ?? []),
    ...Object.keys(config.columnLabels ?? {}),
    ...Object.keys(config.columnWidths ?? {}),
    ...Object.keys(config.columnColors ?? {}),
    ...(config.excelFilterColumns ?? []),
  ]);
  const align = { ...(config.columnAlign ?? {}) };
  for (const c of columns) {
    if (STATUS_COLUMN.test(c)) align[c] = { header: { horizontal: 'left' }, ...align[c], horizontal: 'center' };
  }
  return { ...config, columnAlign: align };
}
